import Vue from 'vue'
import Axios from 'axios'

var staticContentsLoader = {
  loadContent (filePath, thisObject, successFunction) {
    Axios.get(filePath)
      .then((res) => {
        if (typeof successFunction === 'function') {
          successFunction(res, thisObject)
        }
      })
      .catch((error) => {
        console.warn(error)
      })
  }
}

Vue.use({
  install (Vue, options) {
    Vue.prototype['$staticContentsLoader'] = staticContentsLoader
  }
})
export default staticContentsLoader
